module.exports = __webpack_public_path__ + "img/2888.796cbe12.png";